export default "__VITE_ASSET__CuDpADJ2__"